import React, { useEffect, useState } from 'react';
import { HelpListType, SettingsListType } from './types';
import ProfileHeader from './profile-header';
import ProfileSettings from './profile-settings';
import ProfileHelp from './profile-help';
import ManageRoleModal from 'components/manage-role-modal';
import ManageDepartmentModal from 'components/manage-department-modal';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import SavedAddressesSettings from 'components/modals/saved-addresses-settings';
import ManageBrandModal from 'components/manage-brand-modal';
import ChangeWorkModeModal from 'components/modals/change-work-mode';

const Profile = () => {
  const { activeCompany } = useDashboardContext();
  const [imgSrc, setImgSrc] = useState<string | null>('');
  const [email, setEmail] = useState('');
  const [showManageRoleModal, setShowManageRoleModal] = useState(false);
  const [showManageDepartmentModal, setShowManageDepartmentModal] = useState(false);
  const [showManageBrandModal, setShowManageBrandModal] = useState(false);
  const [showWorkModeModal, setShowWorkModeModal] = useState(false);
  const [showManageAddressesModal, setShowManageAddressesModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setImgSrc(activeCompany?.logo);
    const userEmailAddress = activeCompany?.user?.email;
    if (userEmailAddress) {
      setEmail(userEmailAddress);
    }
  }, [activeCompany]);

  const handleManageRole = () => {
    setShowManageRoleModal(!showManageRoleModal);
  };
  const handleChangeWorkMode = () => {
    setShowWorkModeModal(!showWorkModeModal);
  };
  const handleManageDepartment = () => {
    setShowManageDepartmentModal(!showManageDepartmentModal);
  };
  const handleManageBrand = () => {
    setShowManageBrandModal(!showManageBrandModal);
  };
  const handleManagePassword = () => {
    navigate(`/${ROUTE_KEYS.MANAGE_PROFILE_PASSWORD}`);
  };
  const handleChangeEmail = () => {
    navigate(`/${ROUTE_KEYS.CHANGE_EMAIL}`);
  };

  const handleChangeAddress = () => {
    setShowManageAddressesModal(!showManageAddressesModal);
  };
  const SETTINGS_LIST: SettingsListType[] = [
    {
      label: 'Department settings',
      value: `Manage and create departments`,
      buttonText: 'Manage',
      onClick: handleManageDepartment
    },

    {
      label: 'Email',
      value: email,
      onClick: handleChangeEmail
    },

    {
      label: 'Roles',
      value: `Assign and manage admin access`,
      buttonText: 'Manage',
      onClick: handleManageRole
    },
    {
      label: 'Work mode',
      value: 'Manage work mode',
      buttonText: 'Change',
      onClick: handleChangeWorkMode
    },
    {
      label: 'Address',
      value: 'Manage addresses',
      buttonText: 'Change',
      onClick: handleChangeAddress
    },
    { label: 'Password', value: `*********************`, onClick: handleManagePassword }
  ];

  const HELP_LIST: HelpListType[] = [
    {
      label: 'Contact Support',
      route: 'mailto: hello@getfoodcourt.com'
    },
    {
      label: 'Terms & conditions',
      route: 'https://getfoodcourt.com/fcb-terms-and-conditions',
      isExternal: true
    },
    {
      label: 'Privacy policy',
      route: 'https://getfoodcourt.com/fcb-privacy-policy',
      isExternal: true
    }
  ];
  return (
    <div className='w-[95%] max-w-[700px] space-y-8'>
      <ProfileHeader imgSrc={imgSrc} />
      <ProfileSettings list={SETTINGS_LIST} />
      <ProfileHelp list={HELP_LIST} />
      <ManageRoleModal isOpen={showManageRoleModal} onClose={handleManageRole} />
      <ChangeWorkModeModal isOpen={showWorkModeModal} onClose={handleChangeWorkMode} />
      <ManageDepartmentModal isOpen={showManageDepartmentModal} onClose={handleManageDepartment} />
      {showManageBrandModal && (
        <ManageBrandModal isOpen={showManageBrandModal} onClose={handleManageBrand} />
      )}
      <SavedAddressesSettings isOpen={showManageAddressesModal} onClose={handleChangeAddress} />
    </div>
  );
};

export default Profile;
